const LoadingSpinner = ({
  textColor = "text-primary",
  message,
}: {
  textColor?: string;
  message?: string;
}) => {
  return (
    <div className="h-100 w-100 d-flex flex-column justify-content-center align-items-center gap-2">
      <div className={`spinner-border ${textColor}`} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      {message && <p className={`mb-0 ${textColor}`}>{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
